import Vue from "vue";

/**
 * EventBus for signing, email & download events.
 *
 * Signing events:
 *   signing:start  { id, clientName, documentNumber }
 *   signing:done   { id, clientName, documentNumber, data }
 *   signing:error  { id, clientName, documentNumber, message }
 *
 * Email events:
 *   email:start  { id, clientName, documentNumber }
 *   email:done   { id, clientName, documentNumber }
 *   email:error  { id, message }
 *
 * Download events:
 *   download:start  { id, filename, format }
 *   download:done   { id, filename }
 *   download:error  { id, message }
 */
export const signingEventBus = new Vue();
